import styled from 'styled-components'
import Card from '@mui/material/Card'

export const Container = styled(Card)`
    padding: 5px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    color: #000000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #f5f5f5;
`

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 20px;
`
